import gql from "graphql-tag";

export const EQUIPMENT_SUBCATEGORIES_QUERY = gql`
  query equipmentSubcategories {
    equipmentSubcategories {
      equipmentsForInput
      equipmentsForCheckbox
	  }
  }
`;